<template>
    <div class="cc-accessory">
        <div class="cc-accessory__left">
            <a :href="accessory.link" :title="accessory.name">
                <img :src="accessory.thumbnail" :alt="accessory.name" class="cc-accessory__thumbnail">
            </a>
        </div>
        <div class="cc-accessory__main">
            <div class="cc-accessory__title">
                <a :href="accessory.link" :title="accessory.name" class="cc-accessory__link">{{ accessory.name }}</a>
            </div>
            <div class="cc-accessory__attribute-selectors" v-if="accessory.attributes.length > 0">
                <attribute-selectors :attributes="accessory.attributes" @selectAttribute="selectAttribute"/>
            </div>
            <div class="cc-accessory__availability" v-if="selectedAccessory">
                <availability :quantity="selectedAccessory.quantity_available"/>
            </div>
        </div>
        <div class="cc-accessory__right">
            <div class="cc-accessory__prices">
                <div class="cc-price cc-price--accessory">{{ displayAccessoryPrice }}</div>
            </div>
            <div class="cc-accessory__controls">
                <button class="cc-button cc-button--accessory" v-if="selectedCombination" @click="addToCart">{{ translations['Add'] }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import AttributeSelectors from "./AttributeSelectors";
    import Availability from "./Availability";

    export default {
        components: {
            AttributeSelectors,
            Availability,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
            displayAccessoryPrice: function () {
                return this.accessory.is_gift ? this.translations['Free'] : this.accessory.formattedPrices.price;
            },
            selectedAccessory: function () {
                if (this.selectedCombination === undefined) {
                    return;
                }

                return {
                    ...this.accessory,
                    id_attribute: this.selectedCombination,
                };
            },
            selectedCombination: function () {
                let ids = {};
                let combinations = [];

                if (this.accessory.attributes.length === 0) {
                    return 0;
                }

                if (this.selectedAttributes.length !== this.accessory.attributes.length) {
                    return;
                }

                for (let index in this.selectedAttributes) {
                    if (this.selectedAttributes.hasOwnProperty(index) === false) {
                        continue;
                    }

                    const attributeId = this.selectedAttributes[index].attributeId;
                    const groupId = this.selectedAttributes[index].groupId;

                    let found = this.accessory.combinations.filter(item => {
                        return item.attribute === attributeId && item.group === groupId
                    });

                    combinations = [...combinations, ...found];

                    found.forEach(item => {
                        if (ids[item.id] === undefined) {
                            ids[item.id] = [];
                        }

                        ids[item.id].push(item);
                    })
                }

                let selectedId;

                for (let i in ids) {
                    if (ids[i].length !== this.selectedAttributes.length) {
                        continue;
                    }

                    selectedId = i;
                }

                return selectedId;
            }
        },
        data () {
            return {
                selectedAttributes: [],
            };
        },
        methods: {
            addToCart: function () {
                this.$store.dispatch('ADD_PRODUCT', {
                    id: this.accessory.id,
                    id_attribute: this.selectedCombination,
                    quantity: 1
                });
            },
            selectAttribute: function (attribute) {
                const index = this.selectedAttributes.findIndex(item => {
                    return item.groupId === attribute.groupId;
                });

                if (index !== -1) {
                    this.selectedAttributes.splice(index, 1);
                }

                this.selectedAttributes.push(attribute);
            }
        },
        mounted() {
            if (this.selectedAttributes.length > 0) {
                return;
            }

            this.accessory.attributes.forEach(item => {
                this.selectAttribute({
                    groupId: item.id,
                    attributeId: item.values[Object.keys(item.values)[0]].id,
                });
            });
        },
        name: 'Accessory',
        props: [
            'accessory'
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/accessory";
</style>
